export const AssetHolderTypes = {
  user: 'user',
  dispenser: 'dispenser',
  vault: 'vault',
}
